import { render, staticRenderFns } from "./RegrasDesconto.vue?vue&type=template&id=42af213f"
import script from "./RegrasDesconto.vue?vue&type=script&lang=js"
export * from "./RegrasDesconto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports